import * as React from 'react';
import '../../styles/ProgressBar.css';

export interface Props {}

// NOTE: In order to use the LoadingOverlay component make sure that
//       the parent component is using position:relative
function ProgressBar({  }: Props) {
    return (
        <div className="progress">
            <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
            />
        </div>
    );
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/common/ProgressBar.tsx